<template>
  <div class="pagination" v-if="total > 0">
    <div class="item page prev" v-if="pageNum != 1" @click="jumpTo(pageNum - 1)">上一页</div>
    <div class="item page" v-if="continuePage.start > 1" :class="{ active: pageNum == 1 }" @click="jumpTo(1)">1</div>
    <div class="item" v-if="continuePage.start > 2">...</div>
    <template v-for="(page, key) in continuePage.end">
      <div
        v-if="page >= continuePage.start"
        :key="key"
        class="item page"
        :class="{ active: pageNum == page }"
        @click="jumpTo(page)"
      >{{ page }}</div>
    </template>
    <div class="item" v-if="continuePage.end < totalPage - 1 ">...</div>
    <div class="item page" v-if="continuePage.end < totalPage" :class="{ active: pageNum == totalPage }" @click="jumpTo(totalPage)">{{ totalPage }}</div>
    <div class="item page next" v-if="pageNum != totalPage" @click="jumpTo(pageNum + 1)">下一页</div>
    <div class="desc">第{{ pageNum }}页 共{{ totalPage }}页</div>
  </div>
</template>

<script>
export default {
  props: {
    // 列表容器开始高度
    startHeight: {
      type: Number,
    },
    // 当前页
    pageNum: {
      type: Number,
      default: 1,
    },
    // 数据总数
    total: {
      type: Number,
      default: 0,
    },
    // 每页展示数
    pageSize: {
      type: Number,
      default: 10,
    },
    // 连续页码数
    continueCount: {
      type: Number,
      default: 3,
    }
  },
  computed: {
    totalPage() {
      return Math.ceil(this.total / this.pageSize)
    },
    // 计算连续页的开始和结束
    continuePage() {
      let start = 0
      let end = 0

      if (this.totalPage < this.continueCount) { // 总页数小于连续页码数
        start = 1
        end = this.totalPage
      } else {
        start = this.pageNum - parseInt(this.continueCount / 2)
        end = this.pageNum + parseInt(this.continueCount / 2)

        if (start < 1) {
          start = 1
          end = this.continueCount
        }
        if (end > this.totalPage) {
          end = this.totalPage
          start = this.totalPage - this.continueCount + 1
        }
      }

      return { start, end }
    },
  },
  methods: {
    jumpTo(page) {
      // 不执行跳转的情况：目标页等于当前页；目标页小于1；目标页大于总页数；
      if (page == this.pageNum || page < 1 || page > this.totalPage) return false
      // 回到列表顶部
      document.documentElement.scrollTop = this.startHeight

      this.$emit('change', page)
    },
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;

  .item {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 8px;
    min-width: 32px;
    height: 32px;
    font-size: 14px;
    color: #9a7b62;
    background: #fff;
    border: 1px solid #e2d6cb;
    cursor: default;

    &:not(:first-of-type) {
      border-left: 0;
    }
  }

  .page {
    cursor: pointer;
    
    &.active,
    &:hover {
      color: #fff;
      background: #9a7b62;
    }

    &.active {
      cursor: default;
    }
  }

  .desc {
    margin-left: 10px;
    color: #9a7b62;
  }
}
</style>